module.exports = __webpack_public_path__ + "img/simbolo-branco.35d6b9f5.png";